import Vue from 'vue'
import App from './App.vue'
import ElementUI from 'element-ui'
// import axios from "axios"
// import "./assets/css/reset.css"
import router from "./router"
import "element-ui/lib/theme-chalk/index.css"
import 'font-awesome/css/font-awesome.min.css'
import service from '@/api/auth'
import { getToken } from '@/api/auth'
import { KEY_ADMIN_USER_TOKEN } from './api/constants'

// Vue.prototype.axios = axios
Vue.prototype.service = service

Vue.config.productionTip = false

Vue.use(ElementUI)


router.beforeEach((to, from, next) => {
  document.title = '个人开发测试网站';
  if (!getToken(KEY_ADMIN_USER_TOKEN)) {
    if (to.path !== '/login') {
      next('/login')
    } else {
      next()
    }
  }
  next()
})

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')